import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const SignUpAction = createAsyncThunk('signUp',
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.signup, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

const SignUpSlice = createSlice({
    name: 'signUp',
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        SignUpReset: () => {
            return {
                isLoading: false,
                data: false,
                success: false,
                error: null
            }
        }
    },
    extraReducers: {
        [SignUpAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [SignUpAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.success = true;
            state.error = null;
        },
        [SignUpAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { SignUpReset } = SignUpSlice.actions;
export default SignUpSlice.reducer;